import styled from '@emotion/styled'
import { Typography, Box, IconButton } from '@mui/material'

export const Site = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 500,
  fontSize: 18,
  lineHeight: '22px',
  color: theme.palette.grey[800],
}))

export const GraphContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  border: `1px solid ${theme.palette.border.primary}`,
  backgroundColor: theme.palette.common.white,
}))

export const GraphTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}))

export const GraphExpandButton = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  fontSize: 13,
  borderRadius: '50%',
  backgroundColor: '#F7F7F7',
  color: theme.palette.content.tertiary,
  '&:hover': {
    backgroundColor: '#EFEFEF',
  },
}))

export const GraphWrapper = styled(Box)(() => ({
  height: '100%',
  width: '100%',
}))
